import React from 'react'
import '../styles/check.css'

const CheckBox = ({name}) => {
  return (
    
       <div className="check-div">
                <input type="radio" name={name} id="checkboxDesign" />
                <span className="span-check"></span>
              </div> 
   
  )
}

export default CheckBox;